.mainHeaderV2 {
  display: flex;
  width: 100%;
  justify-content: space-between;

  .searchBtn,
  .menuBtn {
    all: unset;
    width: 32px;
    height: 32px;
    display: grid;
    place-items: center;
    filter: drop-shadow(1px 0 5px rgb(0, 0, 0, 0.75));
  }
}